import React from 'react';
import { connect } from "react-redux";
import Login from "./Login";
import Settings from "./Settings";
import { login, fetchLogin } from "../actions/actions";

class MainPage extends React.Component {
    componentDidMount() {
        this.props.fetchLogin();
    }

    render() {
        if (!this.props.logged_user || this.props.logged_user === "") {
            return <Login />;
        } else {
            return <Settings />;
        }
    }
}

const mapStateToProps = (state) => {
    return {
        logged_user: state.user,
    };
};

export default connect(mapStateToProps, { login, fetchLogin })(MainPage);
